
import {
  mdiArrowLeft,
  mdiArrowRight,
  mdiArrowTopRight,
  mdiClose
} from '@mdi/js'

import AppCarousel from '../ui/AppCarousel.vue'

export default {
  mdiArrowLeft,
  mdiArrowRight,
  mdiArrowTopRight,
  mdiClose,

  components: { AppCarousel },

  props: {
    reviews: {
      type: Array,
      required: true
    }
  },

  data () {
    return {
      expandedReview: null
    }
  },

  methods: {
    toggle (item) {
      item.show = !item.show
    },
    setExpandedReview (review) {
      this.expandedReview = review
    }
  }
}
